import { idNestedParamsValidator, validatorBuilder } from '@guiker/api-definition'
import { HttpMethod } from '@guiker/http'

import { PropertyOwnership } from '../../../entity'
import { findOnePropertyOwnershipByPropertyId } from '../schemas'
import { paths } from './paths'

export const propertyOwnershipRoutes = {
  readOnePropertyOwnership: {
    path: paths.propertyOwnership.all.withId(),
    method: HttpMethod.GET,
    authenticated: true,
    pathParamsValidator: idNestedParamsValidator,
    responseValidator: validatorBuilder.buildResponseValidator<PropertyOwnership>(),
  },
  readOneActivePropertyOwnershipByPropertyId: {
    path: `${paths.propertyOwnership.all.base()}/property`,
    method: HttpMethod.GET,
    authenticated: false,
    queryParamsValidator: (payload: unknown) => findOnePropertyOwnershipByPropertyId.validate(payload),
    responseValidator: validatorBuilder.buildResponseValidator<PropertyOwnership>(),
  },
}
